import { TextVerticalSpacer, VerticalSpacer } from '@superhi/design'
import styled from 'styled-components'

export const Wrapper = styled(VerticalSpacer).attrs({
  amount: { small: 24, medium: 32, large: 32 },
})`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const DiscountsText = styled(TextVerticalSpacer).attrs({
  level: '5',
})`
  display: flex;
  flex-direction: column;
  align-items: center;
`
